import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LazyLoadImageModule, intersectionObserverPreset } from 'ng-lazyload-image';

import { SharingModule } from '../SharedModule';

import { NewsDetailRoutingModule } from './news-detail-routing.module';
import { NewsDetailComponent } from './news-detail.component';
import { NewsblurbComponent } from '../newsblurb/newsblurb.component';
import { NewswpengageComponent } from '../newswpengage/newswpengage.component';
import { NewsfileComponent } from '../newsfile/newsfile.component';
import { NewsdoublecontentComponent } from '../newsdoublecontent/newsdoublecontent.component';
import { NewsimagevideoComponent } from '../newsimagevideo/newsimagevideo.component';
import { NewscontentComponent } from '../newscontent/newscontent.component';

@NgModule({
	imports: [
		CommonModule,
		NewsDetailRoutingModule,
		LazyLoadImageModule.forRoot({
			preset: intersectionObserverPreset
		}),
		SharingModule.forRoot(),
	],
	declarations: [
		NewsDetailComponent,
		NewsblurbComponent,
		NewswpengageComponent,
		NewsfileComponent,
		NewsdoublecontentComponent,
		NewsimagevideoComponent,
		NewscontentComponent,	
	],
})
export class NewsDetailModule { }